
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as jwtMya6r2lJ1wO2xn0BvPs4H22Bpcjg1fpGgBmWfpVcOuAMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as riseid_45LVpp_45c7_DJk_inO9wm2SLZ7Uu6QEI4KZmwkL_45FqrWUMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as depositvhQCXJFp1JouQ7tU5MvhKSnN9s3yod2s33lAIju34WoMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as deposit_45uskHVE3BerjEwiSF_45bZ8aAPLRMRcPQRvtiFHhCq72_hUoMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as _91accountId_93MfekLc8ZN71FN1ZEjN4BHjzy9lBzYPQh9cEbZpxztowMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as _91accountId_93rq8AZ8WxuAyxodxNEph3NfdRtCETT_45uVCjYNJj0tX4QMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as fundh21_skka6WPfrLnLug0TdlAe_KYYsdWU4XUWLApwicgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexz_45C6vvDp6P3ty2vLEqXKNg1YDxbUrYMwSFYtGVSZvKIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as riseidkD56nD_B69_3K7hnr0QtCY025JeE93GmT_4518Ks8ZMaYMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as accountnDdt4XjmMjxYkPe3dYCyiQBRm1o_Z7CQBQk8s7iGOUgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as blockedACma3rGJ9niFNyVMMeh_8eu_45NqUq1MykS7sRcdefCMcMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as referralQlnY_45d_451_PhHcooQDfWSunTjYK_7TbjwCBu4t4CYJ2UMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as securityHkmEW0YSj72N_45ysCL3FbuA2vx3HFTkwFhqYEl1W3HOAMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45outFSCTOS_zDtsR4rhke3gXMSxYuo0z6KY8O3uCPnPeovsMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as _91accountId_931cotS4ftVWqoKqPf45RUH1RbZ75XlOhkKFyhhN6Xju8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as _91accountId_93gXmk4apAlX1ff_dkD1eZo_45_45qWWAeyNHTN1MlxcKGW7MMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as withdrawJ1ELgHP3XvbTdRyelNQG_c_0guj7ruYtnlkdxSD7T6QMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
import { default as dashboardi8EAJVzSRJTAEMJbCAwUgua__Z_45dmKxkoI1iHh2m1jcMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developer9TtcJV34OkBmPqMoxeW9d323IbaK8_45avFDhtwRJpD80Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as loginamfvuTYjD4jc_GojT7oDnw8yx3t3HNbw5_AikY6VRV0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as onboardingW7h8GkL_K5JquAwxDE5STbZ3WBjlwsN_45MDnNZ3kJXVQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as playgroundDjfD1T5hxOs6Az2Jz3Wu46YRUJYETgfNjc8kfCDNmCUMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as _2faaepZ2MCwmMMaD7QTM2_cbS_eV_IWlqZ0NhteMa1xSTEMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as indexb63MVPHqYy_45CZf4RtQ_45bpvB9A190aA_45zMnHi4ZYINtEMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as codeZWM1_455Qbz5VNWv_ZkFDckHZWaplFW1ES_45OS0QZ7YLB8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as code__E8EI_45VSbDQcgzS0We_45YTR31OIYAH_RqOcLuhtWMmQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexsw9mH_sOz_45wfS1BTB_tpaiFWvhWeZHHbHyimV0ARVp4Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as registerbybZRgvtwxehC_PyfPH4BCZmVk7fPzdJFBGpqo3oecoMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as indexYLN69_Cxox5HqzopNC29bTHLfnOEYDyGirPYuxFa6gIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as _91code_93Fu9r2g3YaJIhc2P5aPAOjM6IWz0zwOt3PlK8rYHttr8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as indexYI3AcznB39HzjamZVSOxxYcI_45mxzLUwJm0L_452sKjOTQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as sign_45document5WrQcobbJ_gek8OcHbbBs9FRp13o7jNKc8DT_U20UnoMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as indexfRjhsCm4h7MXJGRrG_45A6pnhtWh4I_45XE6G_EEDAEwt7UMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as indexyggavSTV_q8pKIx3MZrzyaGc0EuATUC_4wezhHF5dk0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as importNasBcuv2YY1wGr2EbBCqZHHsKrRt9oRnKbAH9gdyvu8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as directlm_2Fc_6kd6Fd0evZIBj0N0qLklK70xMPAlkwDQQ_v8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubCjeaURKqHUYpL5GimHNm_45QEo_Pzgy1dXGNRWrhSqWrQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmedMGzALi3NJEa5qLTMYPeZOsjZBMDFDPV4P2BBMOOtlfgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as batch_warmedDF2bUDGumgRzvJw2RPO2h_453Q_45vkDQu7JrEdVR52OnOkMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as warmed_lightJkdLl2TVE43zsNcU7RWnAXCocK6BFYm18bN7yworCtMMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as batch_warmed_lightCukBRyfzJK2sG0pZgBYtiVR9f3WPMcGAR1Xu2fjdnTYMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as inviteQwZWkqjd4uiXZ8G7cmASYJH9MO1niWR_yX4wmzzCKCYMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as index96nnfH3IRaQLjzMW3sC4jP5bLMysRk1ktDIwKJ1MggoMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as indexhhEAACqypP5I4JcOTOvwtjAL67C73Xfg_45oLlVIM_45Ze4Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as waiting21aPnaZL6c6v8hKSGEDtttE_vTPPFu6gXG70BMV0RfIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as business2dUnHuByaduVOdZUH3jJVkm0KmztxqDm0DPi0hnCItEMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as callbackpqeFLCR1uT4i4aMClWmrGUjcB_45yPcfqhn40mO_45s5B5QMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as _91id_93pykV0OoK4aHey_O__H_Yrot3hAiAMSNXHIshbk3iJhAMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as index2CMVvkNWPFUvM3n7nPO8mFRgiU7sdqipa0VrsrYZIYcMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as _91uuid_93hWXet2r0AGN7cnODWVLu0CA10EO1EMeSxk5lvsFDkpIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as indexlk2__45zjkLpOUT_45FIDcD7hVx5nXWbAoy39QeT5fFHZDwMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexCrN3wIxiesDTQKMY7_45DG9kGxSaYYN54roXSZwVIh_6EMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexEavb5TTWeBUQoidkaymfBGq4sbdRe14B6SdZzvQYsUQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionsNIIOw4zloM7teFzsn8E5BrdRTOu9rslQ0iNyh30kqIIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as riseid_45erc20_45withdrawHVuvhvBoLepZflwX5NEgpLTmyObFrzvGUrDaDQEbAm0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as _91token_93ttXOD_g6j5CML2ICIwB8fG5hDmtcrnqQoKi0aXs_45hdgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as indexC9vFWEuSAnMZri3geONySgS6mzQMGzE_yz3v3I326HUMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as indexsbXsC5gNuKX1MIznOVmB5IYh7VPLWvEAvLKpCWZG1ykMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as indexLyHAdHz5CB8bD_b_uCjGp4WwDGaVoCrLfr_45fJyrCjo8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as rampsVgAaBMGRmBmto9lNoit3_DKqAOEafHu1EmWVSWklWm8Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as classification_O0iE_TkGCPIWDO68_45OjFJlXrTDEFRzc_45_NNw30KdSMMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as _91id_93oVd7G1vNRnvXSmFeeKQvaHntCagDmzMtan4MBFWdoKUMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as blockchain_45wallet4jgYO2WT3sAz_bKqTLme57_IsEFoIBtBs5_Jf9V1XRsMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addressEX6iYTTntN1alkYJw04AEEBZK2sfpBkROHGDAyuRVyIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsP_kTFvm_SsLJ2jNHm_G0hufn_45f_45e9pfrdnF4DRn28U0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as transaction_45historyPQub4VRK_d1jaXOzfIOSYKUQ_DBtAgA76nV1dj3fcOgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as usyojsbEa9lcn6T4029beZUPcdSyGXnfRW9eMRZA2Ys1cMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as eurVod6_S7xfetpy3WeMYX3zaTIxHE76CdKXx5YRn_451UR4Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as gbpCY9wn9eclcChzTAa4NrdhYNT3eBKQdybbc5DG4pSeTMMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as ngnSCGJNXwiVdH5xC9fVMxsDSw_450YMiA8yWb_Ucoy2Hb3IMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as brlaaoLIlyPuhr_EjUFtoVDA1j_451C0zkeuelHuYIciwF0zcMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as forexg5SGsrZwcWcalpBx5wUo4pCnd4UelGryI2_dnK9mx4EMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as krakendqo8CWaQun4KMr6mWrbU80_DOIAMl8wAqAmiJEyxGKwMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as binancexwByQ1tHf_w7liHGIVpeKhik0mL_yJAezQYkYd8PAOAMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as coinbaserYqZboSvxoO6RDmXpiCRXoqv830QOdaKTQdxxwfeiacMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as international49wmAqSRTJhC_mIIEFVtlTIdPb_45lYKb8fqvnpM7lzmAMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as coinbase_walletNeOgVH1B5i9ZIx9jsTnN8SuyqVzYowH9IYoZKUXbxj4Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as international_bankmqst3615MCYbLu46IZbVeu_45dsHEl3hgU0TbXrNRHkw4Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as indexWzTp78MTlGT8F5XdgiqqCtIsXm55m3KMyxOHg5mfbW0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as _91network_93dJgUE3S_9LBAWlVYdfsyck0OMT21_45ITCTHlNUqy_vLgMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as options_JbAnAAMBYFoImnvvmuCMlc1sMyAmpRfwdRHas1LhW0Meta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as coinbasewmVZblMlccyjrSGzihqP5gx_45_45dyYkdMPi2QN83JFiIIMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as teamt1XIsQJ3jwAD00tJt2cBEejGJ0j55BKEFaOB9HOZfFQMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as _91id_93vZFnaN3TwN_45Kw9ukhQdLhxASSkS5mQakFSum4k_45xs1cMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as indexikf_8JsajuumuZiy_45Oodbn7N55kyc8v7edDVRV2_45A1kMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as verify_45walletZzFiT9_AaL1MHGg7jPzaAvi_45lLZ_Eq_45KhQ7p8bcp4OcMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as pay_scheduleq8G67cvSgeQdEhjD6zUGQTSRsvY3gAkvJ28fkhxOlHEMeta } from "/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
export default [
  {
    name: "jwt",
    path: "/jwt",
    meta: jwtMya6r2lJ1wO2xn0BvPs4H22Bpcjg1fpGgBmWfpVcOuAMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundh21_skka6WPfrLnLug0TdlAe_KYYsdWU4XUWLApwicgMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseid_45LVpp_45c7_DJk_inO9wm2SLZ7Uu6QEI4KZmwkL_45FqrWUMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: depositvhQCXJFp1JouQ7tU5MvhKSnN9s3yod2s33lAIju34WoMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45uskHVE3BerjEwiSF_45bZ8aAPLRMRcPQRvtiFHhCq72_hUoMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93MfekLc8ZN71FN1ZEjN4BHjzy9lBzYPQh9cEbZpxztowMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_93rq8AZ8WxuAyxodxNEph3NfdRtCETT_45uVCjYNJj0tX4QMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexz_45C6vvDp6P3ty2vLEqXKNg1YDxbUrYMwSFYtGVSZvKIMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidkD56nD_B69_3K7hnr0QtCY025JeE93GmT_4518Ks8ZMaYMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: accountnDdt4XjmMjxYkPe3dYCyiQBRm1o_Z7CQBQk8s7iGOUgMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockedACma3rGJ9niFNyVMMeh_8eu_45NqUq1MykS7sRcdefCMcMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referralQlnY_45d_451_PhHcooQDfWSunTjYK_7TbjwCBu4t4CYJ2UMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: securityHkmEW0YSj72N_45ysCL3FbuA2vx3HFTkwFhqYEl1W3HOAMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outFSCTOS_zDtsR4rhke3gXMSxYuo0z6KY8O3uCPnPeovsMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawJ1ELgHP3XvbTdRyelNQG_c_0guj7ruYtnlkdxSD7T6QMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  },
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardi8EAJVzSRJTAEMJbCAwUgua__Z_45dmKxkoI1iHh2m1jcMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developer9TtcJV34OkBmPqMoxeW9d323IbaK8_45avFDhtwRJpD80Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingW7h8GkL_K5JquAwxDE5STbZ3WBjlwsN_45MDnNZ3kJXVQMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexb63MVPHqYy_45CZf4RtQ_45bpvB9A190aA_45zMnHi4ZYINtEMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: indexsw9mH_sOz_45wfS1BTB_tpaiFWvhWeZHHbHyimV0ARVp4Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexYLN69_Cxox5HqzopNC29bTHLfnOEYDyGirPYuxFa6gIMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexYI3AcznB39HzjamZVSOxxYcI_45mxzLUwJm0L_452sKjOTQMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45document5WrQcobbJ_gek8OcHbbBs9FRp13o7jNKc8DT_U20UnoMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexfRjhsCm4h7MXJGRrG_45A6pnhtWh4I_45XE6G_EEDAEwt7UMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: importNasBcuv2YY1wGr2EbBCqZHHsKrRt9oRnKbAH9gdyvu8Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: inviteQwZWkqjd4uiXZ8G7cmASYJH9MO1niWR_yX4wmzzCKCYMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  }
]
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: index96nnfH3IRaQLjzMW3sC4jP5bLMysRk1ktDIwKJ1MggoMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexhhEAACqypP5I4JcOTOvwtjAL67C73Xfg_45oLlVIM_45Ze4Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waiting21aPnaZL6c6v8hKSGEDtttE_vTPPFu6gXG70BMV0RfIMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: business2dUnHuByaduVOdZUH3jJVkm0KmztxqDm0DPi0hnCItEMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93pykV0OoK4aHey_O__H_Yrot3hAiAMSNXHIshbk3iJhAMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: index2CMVvkNWPFUvM3n7nPO8mFRgiU7sdqipa0VrsrYZIYcMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93hWXet2r0AGN7cnODWVLu0CA10EO1EMeSxk5lvsFDkpIMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: indexlk2__45zjkLpOUT_45FIDcD7hVx5nXWbAoy39QeT5fFHZDwMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexCrN3wIxiesDTQKMY7_45DG9kGxSaYYN54roXSZwVIh_6EMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexEavb5TTWeBUQoidkaymfBGq4sbdRe14B6SdZzvQYsUQMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionsNIIOw4zloM7teFzsn8E5BrdRTOu9rslQ0iNyh30kqIIMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdrawHVuvhvBoLepZflwX5NEgpLTmyObFrzvGUrDaDQEbAm0Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93ttXOD_g6j5CML2ICIwB8fG5hDmtcrnqQoKi0aXs_45hdgMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: indexC9vFWEuSAnMZri3geONySgS6mzQMGzE_yz3v3I326HUMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: indexsbXsC5gNuKX1MIznOVmB5IYh7VPLWvEAvLKpCWZG1ykMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indexLyHAdHz5CB8bD_b_uCjGp4WwDGaVoCrLfr_45fJyrCjo8Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: rampsVgAaBMGRmBmto9lNoit3_DKqAOEafHu1EmWVSWklWm8Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classification_O0iE_TkGCPIWDO68_45OjFJlXrTDEFRzc_45_NNw30KdSMMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93oVd7G1vNRnvXSmFeeKQvaHntCagDmzMtan4MBFWdoKUMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsP_kTFvm_SsLJ2jNHm_G0hufn_45f_45e9pfrdnF4DRn28U0Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45historyPQub4VRK_d1jaXOzfIOSYKUQ_DBtAgA76nV1dj3fcOgMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: options_JbAnAAMBYFoImnvvmuCMlc1sMyAmpRfwdRHas1LhW0Meta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  }
]
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamt1XIsQJ3jwAD00tJt2cBEejGJ0j55BKEFaOB9HOZfFQMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93vZFnaN3TwN_45Kw9ukhQdLhxASSkS5mQakFSum4k_45xs1cMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexikf_8JsajuumuZiy_45Oodbn7N55kyc8v7edDVRV2_45A1kMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletZzFiT9_AaL1MHGg7jPzaAvi_45lLZ_Eq_45KhQ7p8bcp4OcMeta || {},
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/gh23/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  }
]